/* ─── Naire Landing · vanilla JS para Shopify ─── */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.naire-landing');
    if (!root) return;

    // Tabs
    var tabBtns = root.querySelectorAll('[data-naire-tab]');
    var tabPanels = root.querySelectorAll('[data-naire-panel]');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-naire-tab');
        tabBtns.forEach(function (b) { b.classList.remove('naire-active'); });
        tabPanels.forEach(function (p) { p.classList.remove('naire-active'); });
        btn.classList.add('naire-active');
        var panel = root.querySelector('[data-naire-panel="' + target + '"]');
        if (panel) panel.classList.add('naire-active');
      });
    });

    // FAQ accordion
    var faqRows = root.querySelectorAll('[data-naire-faq]');
    faqRows.forEach(function (row) {
      var btn = row.querySelector('.naire-faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = row.classList.contains('naire-open');
        faqRows.forEach(function (r) { r.classList.remove('naire-open'); });
        if (!isOpen) row.classList.add('naire-open');
      });
    });

    // Autoplay videos on scroll (muted required by browsers)
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            v.muted = true;
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function(){});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.5 });
      root.querySelectorAll('video[data-naire-autoplay]').forEach(function (v) {
        v.muted = true;
        v.setAttribute('muted', '');
        vio.observe(v);
      });
    }

    // Reveal-on-scroll
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('naire-in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12 });
      root.querySelectorAll('.naire-reveal').forEach(function (el) { io.observe(el); });
    } else {
      root.querySelectorAll('.naire-reveal').forEach(function (el) { el.classList.add('naire-in'); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
